









import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {部署型} from '@/type/department/department';
import {loginModule} from '@/store/authentication/login';

@Component({})
export default class DepartmentSelector extends Vue {
  @Prop({default: null})
  private value!: string | null;
  @Prop({default: true})
  private nullable!: boolean;
  @Prop({default: false})
  private disabled!: boolean;

  private 部署一覧: 部署型[] = [];
  private 利用ユーザーである: boolean = false;

  public mounted(): void {
    this.initialize();
  }

  @Emit('input')
  private update(event: Event): string | null {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      return target.value as string;
    }
    return null;
  }

  private async initialize(): Promise<void> {
    this.部署一覧 = await api.部署一覧を取得する();
    this.利用ユーザーである = !loginModule.管理者である;
  }

  private 編集不可(): boolean {
    if (this.利用ユーザーである) {
      return true;
    }
    return this.disabled;
  }
}
